



































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { RootStoreState } from '../../../../store';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { State } from 'vuex-class';
import { envCongif } from '@/shared/env.config';
@Component({
  components: {
    ...UUIFComponent,
  },
  directives: {
    tooltip,
  },
})
export default class ServiceStatusDialog extends SwExtendedVue {
  @Prop()
  showServiceStatusDialog: boolean;
  @Prop()
  service: any;
  @Prop()
  activeTenantId: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  serviceStatus: any = {};
  accessCode: any = '';
  closeDialog() {
    this.$emit('closeDialog');
  }
  mounted() {
    this.getServiceStatus();
  }
  getServiceStatus() {
    const request  = {
      serialNumber: this.productDetails.serialNumber,
      rootServiceID: this.service.serviceId,
    };
    this.$store.dispatch('MswProductsStoreModule/getServiceStatus', request)
      .then((res: any) => {
        if (res.operationStatus === 'OK') {
          this.serviceStatus = res.content;
        }
        this.$store.commit('stopLoading');
      });
  }
  urlClick(url: string) {
    if (this.serviceStatus && (this.serviceStatus.isNewCCSSOEnabled === 'YES')) {
      this.getAccessCode(this.serviceStatus.appName)
      .then(() => {
        const form = document.createElement('form');
        form.target = 'view';
        form.method = 'POST';
        form.action = `${envCongif.api_url}/redirect-to-application-with-code`;
        const params: any = {
          appName: this.serviceStatus.appName,
          serNo: this.serviceStatus.serialnumber,
          tenant: this.activeTenantId,
          accessCode: this.accessCode,
        };

        for (const i in params) {
          if (params.hasOwnProperty(i)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = i;
            input.value = params[i];
            form.appendChild(input);
          }
        }
        document.body.appendChild(form);
        form.submit();
        window.open('', 'view');
      });
    } else {
      if (url.indexOf('~/') === 0) {
        this.$store.dispatch('navigateTo', url);
      } else {
        window.open(url, '_blank');
      }
    }
  }
  copyToClipBoard(url: any) {
    /*const aux = document.createElement('div');
    aux.setAttribute('contentEditable', 'true');
    aux.innerHTML = url;
    aux.setAttribute('onfocus', 'document.execCommand(\'selectAll\',false,null)');
    document.body.appendChild(aux);
    aux.focus();
    document.execCommand('copy');
    document.body.removeChild(aux);*/
    window.navigator.clipboard.writeText(url);
    this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: 'Copied to clipboard!' });
  }
  async getAccessCode(ele : any) {
    let returnFlag = false;
    const req = {
      tenantId : this.activeTenantId.toString(),
      tileName: ele,
    };
    await this.$store.dispatch('SpogHomepageStoreModule/getCscAccessCode', req)
    .then((result : any) => {
      this.$store.commit('stopLoading');
      if (result.operationStatus === 'OK') {
        returnFlag = true;
        this.accessCode =  result.content.accessCode || 'error';
      } else {
        this.accessCode = 'error';
      }
    });
    return returnFlag;
  }
}
